import axios from 'axios';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
import { useEffect, useState } from 'react';
import { FaArrowRight } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';
import '../HomePage.css';

// const BASE_URL = "http://localhost:8000";
const BASE_URL = "https://idealpursuits.co.in/api";

const MentorSection = () => {
    const [mentors, setMentors] = useState([]);
    const navigate = useNavigate();

    useEffect(() => {
        const fetchMentorData = async () => {
            try {
                const response = await axios.post(`${BASE_URL}/mentor/getMentorsDetails.php`);
                setMentors(response.data.slice(0, 7));
            } catch (error) {
                console.error('Error fetching mentor data:', error);
            }
        };

        fetchMentorData();
    }, []);

    return (
        <section className="mentors-section" id="mentors">
            <div className="container mx-auto py-12">
                <h2>Gain valuable insights and personalized advice from <br /> Our Career Coaches</h2>
                <p className="expert-additional-info">
                    Get valuable insights from our career coaches to help you in the journey of finding and achieving your dream career!
                </p>
                <p className="text-gray-600 mb-8">Are you willing to enroll as a Career Coach? <a href="/#/career-coach-enrollment">Enroll Now</a></p>

                {/* Mentor Grid */}
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
                    {mentors.map((mentor, index) => (
                        <motion.div
                            key={mentor.mentorId}
                            className="mentor-card bg-white shadow-lg rounded-lg overflow-hidden flex flex-col"
                            initial={{ opacity: 0, scale: 0.9 }}
                            whileInView={{ opacity: 1, scale: 1 }}
                            viewport={{ once: true }}
                            transition={{ duration: 0.6, ease: 'easeOut' }}
                        >
                            <img
                                src={`${BASE_URL}/images/profile/${mentor.profileImageName}`}
                                alt={mentor.name}
                                className="w-full h-48 object-cover"
                            />
                            <div className="p-6 flex flex-col flex-grow">
                                <h3 className="text-xl font-bold mb-2">{mentor.name}</h3>
                                <p className="text-gray-500 mb-4">{mentor.profession}</p>
                                <p className="mb-4">{mentor.experience}</p>
                                <div className="flex items-center mb-4">
                                    <Star className="w-5 h-5 text-yellow-400 mr-1" />
                                    <span className="text-gray-700 font-bold">{mentor.rating.toFixed(1)}</span>
                                </div>
                                <div className="mt-auto">
                                    <button
                                        className="cta-button w-full"
                                        onClick={() => navigate(`/career-coach-profile/${mentor.mentorId}`)}
                                    >
                                        Book Now
                                    </button>
                                </div>
                            </div>
                        </motion.div>
                    ))}
                </div>
            </div>
            <button onClick={() => navigate('/career-coaches')} className="more-button">
                View All Career Coaches
                <FaArrowRight className="arrow-icon" />
            </button>
        </section>
    );
};

export default MentorSection;
